import { Button } from '@ontruck/orc';
import styled from 'styled-components';

export default styled(Button)`
  background: var(--primary-btn500);
  :hover {
    background: var(--primary-btn500);
    border-color: var(--primary-btn500);
    opacity: 0.8;
  }
`;
